import { isString, objectGuard } from 'pure-parse'

export type BlockContent = {
  _uid: string
  component: string
} & Record<string, unknown>

// TODO other checks, such as check for uid
export const isBlockContent = objectGuard({
  _uid: isString,
  component: isString,
})

export const isBlocksContent = (data: unknown): data is BlockContent[] =>
  Array.isArray(data) && data.every(isBlockContent)
